/* eslint-disable import/namespace */
import styled from 'styled-components';
import { TOP_BAR_HEIGHT } from '../../domain/lotEditor/constants';

export type FlexProps = {
  w?: string,
  h?: string,
  ai?: string;
  p?: string;
  m?: string;
  br?: string;
  bs?: string,
  bc?: string,
  of?: string,
  wrap?: string,
  d?: string;
  g?: string;
  minw?: string;
  minh?: string;
  cursor?: string;
  ofy?: string;
  ofx?: string;
  jc?: string;
  wordBreak?: string;
  position?: string;
  border?: string;
  maxh?: string;
  maxw?: string;
  ac?: string;
  hover?: string;
  top?: string;
  left?: string;
  zi?: string;
  shrink?: string;
};

export const FlexBox = styled.div<FlexProps>`
  display: flex;
  align-items: ${(props) => (props.ai ? props.ai : 'center')};
  width: ${(props) => (props.w ? props.w : '100%')};
  height: ${(props) => (props.h ? props.h : '100%')};
  min-width: ${(props) => (props.minw ? props.minw : '0')};
  min-height: ${(props) => (props.minh ? props.minh : '0')};
  max-width: ${(props) => props.maxw && props.maxw};
  max-height: ${(props) => props.maxh && props.maxh};
  padding: ${(props) => (props.p ? props.p : '0 0 0 0')};
  margin: ${(props) => (props.m ? props.m : '0 0 0 0')};
  border-radius: ${(props) => (props.br ? props.br : '0')};
  box-shadow: ${(props) => (props.bs ? props.bs : 'none')};
  background-color: ${(props) => (props.bc ? props.bc : 'inherit')};
  overflow: ${(props) => (props.of ? props.of : 'visible')};
  overflow-y: ${(props) => (props.ofy ? props.ofy : 'visible')};
  overflow-x: ${(props) => (props.ofx ? props.ofx : 'visible')};
  flex-wrap: ${(props) => (props.wrap ? props.wrap : 'nowrap')};
  flex-direction: ${(props) => (props.d ? props.d : 'row')};
  flex-shrink: ${(props) => (props.shrink ? props.shrink : '1')};
  ${(props) => props.zi && `z-index: ${props.zi}`};
  flex-grow: ${(props) => (props.g ? props.g : '0')};
  cursor: ${(props) => (props.cursor ? props.cursor : 'auto')};
  justify-content: ${(props) => (props.jc ? props.jc : 'flex-start')};
  ${(props) => props.position && `position: ${props.position}`};
  ${(props) => props.border && `border: ${props.border}`};
  ${(props) => props.ac && `align-content: ${props.ac}`};
  ${(props) => props.top && `top: ${props.top}`};
  ${(props) => props.left && `left: ${props.left}`};
  &:hover{
    ${(props) => props.hover}
  }
`;

export const FlexAround = styled(FlexBox)<FlexProps>`
  justify-content: space-around !important;
`;

export const FlexBetween = styled(FlexBox)<FlexProps>`
  justify-content: space-between !important;
`;

export const FlexStart = styled(FlexBox)<FlexProps>`
  justify-content: flex-start !important;
`;

export const FlexCenter = styled(FlexBox)<FlexProps>`
  justify-content: center !important;
`;

export const FlexEnd = styled(FlexBox)<FlexProps>`
  justify-content: flex-end !important;
`;

export const FlexEvenly = styled(FlexBox)<FlexProps>`
  justify-content: space-evenly !important;
`;

export const AgreementContainer = styled(FlexBox)<FlexProps>`
`;

export const LotContainer = styled(FlexStart)<FlexProps>`
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  flex-direction: column;
`;

export const TopBarContainer = styled(FlexStart)<FlexProps>`
  background-color: #ffffff;
  border: 1px solid  #CED4D9;
  height: ${TOP_BAR_HEIGHT};
  width: 100vw;
  padding: 0 2rem 0 32rem;
`;
